<template>
  <lg-finder
    :id="this.id"
    :fields="fields"
    ref="finder"
    placeholder="Informe o nome do usuario"
    :title="title"
    url="/api/pessoa"
    filterBy="nome"
    :othersFilters="othersFilters"
    @onSelect="onSelect"
    filtrarSituacao
  />
</template>

<script>
import LgFinder from "@/core/components/Inputs/LgFinder.vue";

export default {
  components: {
    LgFinder,
  },

  props: {
    id: String,
    title: String,
  },

  data() {
    return {

      fields: [
        {
          key: "action",
          label: " ",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 text-center w-10",
        },
        {
          key: "usuario.login",
          label: "Login",
          thClass: "pt-1 pb-0",
          tdClass: "py-0  ",
        },
        {
          key: "nome",
          label: " Nome De Usuario",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 ",
        },
        {
          key: "situacao",
          label: "Situação",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 ",
        },
      ],
      othersFilters: [],
    };
  },

  async mounted() {
    this.othersFilters = [];
  },

  methods: {
    async show() {
      await this.$refs.finder.show();
    },

    async onSelect(item) {
      this.$emit("onSelect",  item);
      await this.$bvModal.hide(this.id);
    },
  },
};
</script>
